export default __webpack_public_path__ + "static/carousel5-b81d0e874f56d1120c84d1f09c76b0f3.png";